import Image from './ImageFactory';
export default Image;
//# sourceMappingURL=index.js.map